import DomainResource from './DomainResource';
import merge from 'lodash/merge';

/**
 * Per-organization reference text (prescribed next steps) for a single risk flag
 * category, with one field per risk level. Shown read-only in the risk flag dialog.
 * `category` is a slug from client/src/common/riskFlagConstants.js.
 */
export default class BN_PatientRiskFlagConfig extends DomainResource {
    static _className = 'BN_PatientRiskFlagConfig';

    _objectStructure = {
        category: String,
        high: String,
        moderate: String,
        low: String,
        historical: String,
    };

    _objectDefaults = {
        experimental: false,
    };

    constructor(constructJson, className = 'BN_PatientRiskFlagConfig') {
        super(constructJson, className);
        this.createAndPopulateStructure(this._objectStructure, constructJson, this._objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this._objectStructure));
    }
}
